// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"d74b6c718214150d1050","532":"9bf710cefe4deeb99730","678":"0bec27c40d798fc9fd53","883":"dab60f76ac96dbd7adff"}[chunkId] + ".js";
};